export const getOrderPalletsPath = (orderId, palletId = null) => {
	if (!orderId) return null;
	const basePath = `/orders/${orderId}/show/pallets`;
	return palletId ? `${basePath}?palletId=${palletId}` : basePath;
};

export const getOrderPalletsHashPath = (orderId, palletId = null) => {
	const path = getOrderPalletsPath(orderId, palletId);
	return path ? `#${path}` : null;
};

export const getPalletOrderPath = (pallet, useHash = true) => {
	if (!pallet) return null;

	const orderId = pallet.reserved_order_id || pallet.order_id;
	if (!orderId) return null;

	return useHash
		? getOrderPalletsHashPath(orderId, pallet.id)
		: getOrderPalletsPath(orderId, pallet.id);
};
